import { Tag } from 'antd'
import styled from 'styled-components'

const TagStyled = styled(Tag)`
  width: min-content;
  margin: 0;
`

export default TagStyled
